import styles from "./herosectionartwork.module.scss";

export const HeroSectionArtwork = () => {
    return (
        <svg
            className={styles.artwork}
            width="1899"
            height="264"
            viewBox="0 0 1899 264"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M993.484 223.492C993.293 223.396 993.142 223.229 993.061 223.021C991.901 220.076 989.948 217.56 987.447 215.791C984.947 214.022 982.011 213.078 979.008 213.078C976.005 213.078 973.069 214.022 970.568 215.791C968.068 217.56 966.115 220.076 964.955 223.021C964.874 223.229 964.723 223.396 964.532 223.492C962.041 224.716 959.93 226.67 958.446 229.124C956.962 231.578 956.166 234.431 956.152 237.349C956.131 245.598 962.42 252.48 970.171 252.689C972.99 252.768 975.769 251.961 978.159 250.369V260.795C978.159 261.033 978.248 261.262 978.407 261.431C978.566 261.6 978.781 261.695 979.006 261.695C979.23 261.695 979.445 261.6 979.604 261.431C979.763 261.262 979.852 261.033 979.852 260.795V250.369C982.134 251.893 984.775 252.699 987.47 252.694H987.842C995.592 252.484 1001.88 245.603 1001.86 237.353C1001.85 234.435 1001.05 231.582 999.568 229.127C998.085 226.672 995.974 224.717 993.484 223.492ZM987.798 250.893C985.177 250.972 982.599 250.177 980.423 248.621C980.245 248.495 980.053 248.393 979.852 248.317V237.947L989.542 232.797C989.743 232.69 989.895 232.502 989.966 232.276C990.037 232.049 990.021 231.802 989.92 231.588C989.82 231.374 989.644 231.212 989.431 231.136C989.218 231.061 988.985 231.078 988.784 231.185L979.852 235.936V228.39C979.852 228.152 979.763 227.923 979.604 227.754C979.445 227.585 979.23 227.49 979.006 227.49C978.781 227.49 978.566 227.585 978.407 227.754C978.248 227.923 978.159 228.152 978.159 228.39V241.336L969.227 236.586C969.026 236.479 968.794 236.462 968.581 236.537C968.368 236.613 968.191 236.775 968.091 236.989C967.99 237.202 967.974 237.45 968.045 237.676C968.116 237.903 968.269 238.09 968.47 238.197L978.159 243.348V248.317C977.958 248.393 977.766 248.495 977.588 248.621C975.413 250.178 972.834 250.973 970.213 250.893C967.345 250.817 964.586 249.709 962.386 247.751C960.186 245.793 958.674 243.101 958.096 240.112C957.519 237.124 957.911 234.016 959.207 231.294C960.504 228.572 962.629 226.398 965.236 225.125C965.81 224.842 966.264 224.34 966.506 223.719C967.537 221.099 969.273 218.862 971.495 217.289C973.718 215.716 976.329 214.876 978.999 214.876C981.67 214.876 984.28 215.716 986.503 217.289C988.726 218.862 990.462 221.099 991.493 223.719C991.735 224.34 992.188 224.842 992.762 225.125C995.369 226.398 997.494 228.571 998.79 231.291C1000.09 234.011 1000.48 237.118 999.904 240.106C999.329 243.094 997.819 245.786 995.62 247.745C993.422 249.704 990.665 250.814 987.798 250.893Z"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
            </g>

            <path
                d="M1046.73 251.838C1056.33 251.838 1064.11 243.012 1064.11 232.124C1064.11 221.236 1056.33 212.41 1046.73 212.41C1037.13 212.41 1029.35 221.236 1029.35 232.124C1029.35 243.012 1037.13 251.838 1046.73 251.838Z"
                stroke="#777777"
                stroke-width="2"
            />
            <path
                d="M1046.73 224.731V251.838"
                stroke="#777777"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M1053.68 250.198C1051.51 251.28 1049.13 251.839 1046.73 251.838C1044.33 251.839 1041.96 251.279 1039.78 250.198"
                stroke="#777777"
                stroke-width="2"
            />
            <path
                d="M1046.73 251.838V261.695M1046.73 234.588L1053.68 227.195M1046.73 243.213L1039.78 235.82"
                stroke="#777777"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M1487.19 219.114C1487 219.019 1486.84 218.851 1486.76 218.644C1485.6 215.698 1483.65 213.183 1481.15 211.414C1478.65 209.645 1475.71 208.701 1472.71 208.701C1469.71 208.701 1466.77 209.645 1464.27 211.414C1461.77 213.183 1459.82 215.698 1458.66 218.644C1458.58 218.851 1458.43 219.019 1458.23 219.114C1455.74 220.338 1453.63 222.292 1452.15 224.746C1450.66 227.2 1449.87 230.053 1449.86 232.971C1449.83 241.221 1456.12 248.102 1463.87 248.312C1466.69 248.391 1469.47 247.584 1471.86 245.991V256.417C1471.86 256.656 1471.95 256.885 1472.11 257.054C1472.27 257.222 1472.48 257.317 1472.71 257.317C1472.93 257.317 1473.15 257.222 1473.31 257.054C1473.47 256.885 1473.56 256.656 1473.56 256.417V245.991C1475.84 247.515 1478.48 248.321 1481.17 248.316H1481.55C1489.29 248.107 1495.58 241.225 1495.56 232.976C1495.55 230.058 1494.75 227.204 1493.27 224.749C1491.79 222.294 1489.68 220.339 1487.19 219.114ZM1481.5 246.516C1478.88 246.594 1476.3 245.8 1474.13 244.243C1473.95 244.117 1473.76 244.015 1473.56 243.939V233.57L1483.24 228.419C1483.45 228.312 1483.6 228.125 1483.67 227.898C1483.74 227.672 1483.72 227.424 1483.62 227.211C1483.52 226.997 1483.35 226.834 1483.13 226.759C1482.92 226.683 1482.69 226.701 1482.49 226.808L1473.56 231.558V224.013C1473.56 223.774 1473.47 223.545 1473.31 223.376C1473.15 223.208 1472.93 223.113 1472.71 223.113C1472.48 223.113 1472.27 223.208 1472.11 223.376C1471.95 223.545 1471.86 223.774 1471.86 224.013V236.959L1462.93 232.208C1462.73 232.102 1462.5 232.084 1462.28 232.16C1462.07 232.235 1461.89 232.398 1461.79 232.611C1461.69 232.825 1461.68 233.072 1461.75 233.299C1461.82 233.525 1461.97 233.713 1462.17 233.82L1471.86 238.971V243.939C1471.66 244.015 1471.47 244.117 1471.29 244.243C1469.12 245.801 1466.54 246.595 1463.92 246.516C1461.05 246.439 1458.29 245.331 1456.09 243.374C1453.89 241.416 1452.38 238.723 1451.8 235.735C1451.22 232.746 1451.61 229.638 1452.91 226.916C1454.21 224.195 1456.33 222.021 1458.94 220.748C1459.51 220.465 1459.97 219.963 1460.21 219.341C1461.24 216.722 1462.98 214.485 1465.2 212.911C1467.42 211.338 1470.03 210.498 1472.7 210.498C1475.37 210.498 1477.98 211.338 1480.21 212.911C1482.43 214.485 1484.17 216.722 1485.2 219.341C1485.44 219.963 1485.89 220.465 1486.47 220.748C1489.07 222.02 1491.2 224.193 1492.49 226.913C1493.79 229.634 1494.18 232.741 1493.61 235.729C1493.03 238.716 1491.52 241.409 1489.32 243.368C1487.13 245.326 1484.37 246.436 1481.5 246.516Z"
                fill="#777777"
                className={styles.rectWithFill}
            />
            <path
                d="M1528.27 247.46C1537.87 247.46 1545.65 238.634 1545.65 227.746C1545.65 216.859 1537.87 208.032 1528.27 208.032C1518.68 208.032 1510.9 216.859 1510.9 227.746C1510.9 238.634 1518.68 247.46 1528.27 247.46Z"
                stroke="#777777"
                stroke-width="2"
            />
            <path
                d="M1528.27 220.353V247.46"
                stroke="#777777"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M1535.23 245.82C1533.05 246.901 1530.68 247.461 1528.27 247.46C1525.87 247.461 1523.5 246.901 1521.32 245.82"
                stroke="#777777"
                stroke-width="2"
            />
            <path
                d="M1528.27 247.46V257.317M1528.27 230.21L1535.23 222.818M1528.27 238.835L1521.32 231.442"
                stroke="#777777"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M778.943 252.138C788.541 252.138 796.322 243.312 796.322 232.424C796.322 221.537 788.541 212.71 778.943 212.71C769.345 212.71 761.563 221.537 761.563 232.424C761.563 243.312 769.345 252.138 778.943 252.138Z"
                stroke="#777777"
                stroke-width="2"
            />
            <path
                d="M778.943 225.031V252.138"
                stroke="#777777"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M785.894 250.498C783.718 251.579 781.345 252.139 778.942 252.138C776.54 252.139 774.167 251.579 771.99 250.498"
                stroke="#777777"
                stroke-width="2"
            />
            <path
                d="M778.942 252.138V261.995M778.942 234.888L785.894 227.496M778.942 243.513L771.99 236.12"
                stroke="#777777"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M257.613 252.143C267.211 252.143 274.992 243.317 274.992 232.429C274.992 221.542 267.211 212.716 257.613 212.716C248.014 212.716 240.233 221.542 240.233 232.429C240.233 243.317 248.014 252.143 257.613 252.143Z"
                stroke="#777777"
                stroke-width="2"
            />
            <path
                d="M257.613 225.037V252.143"
                stroke="#777777"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M264.565 250.503C262.388 251.585 260.015 252.145 257.613 252.143C255.211 252.144 252.838 251.585 250.661 250.503"
                stroke="#777777"
                stroke-width="2"
            />
            <path
                d="M257.613 252.143V262M257.613 234.893L264.565 227.501M257.613 243.518L250.661 236.126"
                stroke="#777777"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M19.0006 252.143C28.599 252.143 36.3801 243.317 36.3801 232.429C36.3801 221.542 28.599 212.716 19.0006 212.716C9.40215 212.716 1.62109 221.542 1.62109 232.429C1.62109 243.317 9.40215 252.143 19.0006 252.143Z"
                stroke="#777777"
                stroke-width="2"
            />
            <path
                d="M19.0002 225.037V252.143"
                stroke="#777777"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M25.9524 250.503C23.7761 251.585 21.4029 252.145 19.0006 252.143C16.5984 252.145 14.2252 251.585 12.0488 250.503"
                stroke="#777777"
                stroke-width="2"
            />
            <path
                d="M19.0006 252.143V262M19.0006 234.894L25.9524 227.501M19.0006 243.518L12.0488 236.126"
                stroke="#777777"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />

            <g>
                <path
                    d="M88.5395 14.2964C88.883 14.2828 89.2281 14.276 89.5748 14.276C91.8784 14.276 94.1155 14.5783 96.2525 15.1475C102.898 16.2807 106.164 16.3037 109.662 13.2439C103.409 5.20465 104.506 2.62491 89.4922 9.64646M88.5395 14.2964C85.91 14.4003 83.3756 14.8982 80.9872 15.736C74.071 16.7239 71.0778 16.2532 67.8328 12.9871C76.1599 6.54845 80.8005 5.67115 88.993 11.8533M88.5395 14.2964C88.6914 13.422 88.8388 12.6161 88.993 11.8533M88.993 11.8533C89.1488 11.0823 89.3114 10.3553 89.4922 9.64646M89.4922 9.64646C90.129 7.15021 90.992 4.87764 92.5805 1.68994"
                    stroke="#777777"
                    stroke-width="3.32628"
                    stroke-linecap="round"
                />
                <path
                    d="M70.7812 33.8714C71.2003 33.1754 71.6717 32.4606 72.1988 31.7175M68.9257 37.7269C67.7049 41.2027 67.7625 44.6557 68.6042 49.47M64.5903 59.0991C62.3829 54.9215 61.1245 50.1044 61.1245 44.9759C61.1245 32.1696 68.971 21.3058 79.8463 17.4906C82.2346 16.6527 84.769 16.1548 87.3985 16.0509C87.742 16.0374 88.0872 16.0305 88.4338 16.0305C90.7375 16.0305 92.9745 16.3328 95.1116 16.9021C106.966 20.0598 115.743 31.4315 115.743 44.9759C115.743 49.3074 114.846 53.4167 113.237 57.1061C92.959 55.6335 82.3449 56.131 64.5903 59.0991Z"
                    stroke="#777777"
                    stroke-width="3.32628"
                    stroke-linecap="round"
                />
                <path
                    d="M51.5299 95.9979C70.448 86.4485 109.723 85.5946 159.464 92.1265C180.501 94.889 189.814 96.353 199.964 101.329M114.223 133.401C126.209 169.986 128.924 186.204 128.022 209.355M63.2642 59.3869C81.0188 56.4188 91.6329 55.9213 111.911 57.3939M36.3857 80.8996C36.2462 74.2367 38.7142 67.4993 45.1779 64.2237C89.1196 47.5676 169.429 61.6303 197.082 74.2446C214.003 81.9635 215.62 88.8568 215.62 95.4964C215.225 107.756 189.045 107.134 183.135 116.332C153.096 163.088 166.927 257.828 166.927 257.828C149.274 263.401 139.351 263.378 121.695 257.828C121.695 257.828 123.454 159.582 97.5651 126.7C71.6765 93.817 37.0393 112.112 36.3857 80.8996Z"
                    stroke="#777777"
                    stroke-width="3.32628"
                    stroke-linecap="round"
                />
            </g>

            {/* hall */}
            <svg className={styles.secondMonument}>
                <path
                    d="M524.499 43.9243C534.333 64.7377 536.109 118.806 535.767 143.238H494.792C495.338 78.5966 502.076 50.095 505.377 43.9243H524.499Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M519.774 69.2686C524.558 80.5708 525.422 109.931 525.256 123.199H505.322C505.588 88.0965 508.866 72.6194 510.471 69.2686H519.774Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="508.37"
                    y="35.3779"
                    width="12.7477"
                    height="1.1788"
                    rx="0.5894"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="445.464"
                    y="63.3745"
                    width="12.7477"
                    height="1.1788"
                    rx="0.5894"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="571"
                    y="63.6687"
                    width="12.7477"
                    height="1.1788"
                    rx="0.5894"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="355.573"
                    y="190.297"
                    width="88.2404"
                    height="55.3521"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="355.573"
                    y="222.202"
                    width="88.0589"
                    height="23.4471"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="355.573"
                    y="190.297"
                    width="88.0589"
                    height="14.9848"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M318.235 198.818V159.207H384.9V190.489H355.658V198.818H318.235Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="331.697"
                    y="169.738"
                    width="11.2179"
                    height="12.7982"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="358.016"
                    y="169.738"
                    width="11.2179"
                    height="12.7982"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.529 255.519H443.826V190.299H384.776V159.168H318.178V143.184H514.529"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.529 151.036H318.178V159.208H514.529"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.499 206.204H443.84V214.405H514.499"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.499 214.404H443.84V222.605H514.499"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.499 222.605H443.84V230.806H514.499"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.499 230.805H443.84V239.006H514.499"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.499 239.005H443.84V247.206H514.499"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="326.686"
                    y="235.906"
                    width="9.76833"
                    height="14.5749"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M404.693 174.981V190.333M404.693 174.981C396.243 162.699 387.93 169.864 384.83 174.981V190.333H404.693M404.693 174.981C411.309 169.864 428.42 162.699 443.939 174.981V190.333H404.693"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M483.43 175.065C468.243 161.156 450.775 169.27 443.939 175.065V206.156H483.43V175.065Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M504.629 175.066C496.204 162.217 486.985 169.712 483.429 175.066V206.157H504.629M504.629 175.066V206.157M504.629 175.066C505.691 172.168 509.146 166.431 514.467 166.667M504.629 206.157H514.467"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.744 262.002H311.612C311.612 249.821 311.612 224.841 311.612 222.365L318.263 198.789H355.675V205.272H443.939V206.157H514.467"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M355.536 222.217H311.612V262.002H345.144L355.536 245.499V222.217Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M363.434 233.121V245.646H370.916V233.121C368.145 229.349 364.773 231.549 363.434 233.121Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M378.122 233.121V245.646H385.604V233.121C382.833 229.349 379.461 231.549 378.122 233.121Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M393.641 233.121V245.646H401.123V233.121C398.352 229.349 394.98 231.549 393.641 233.121Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="366.206"
                    y="251.098"
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="374.796"
                    y="251.098"
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="383.387"
                    y="251.098"
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="391.978"
                    y="251.098"
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="400.569"
                    y="251.098"
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="409.16"
                    y="251.098"
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="417.751"
                    y="251.098"
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="426.342"
                    y="251.098"
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="434.932"
                    y="251.098"
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="366.206"
                    y="196.579"
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="374.796"
                    y="196.579"
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="383.387"
                    y="196.579"
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="391.978"
                    y="196.579"
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="400.569"
                    y="196.579"
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="409.16"
                    y="196.579"
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="417.751"
                    y="196.579"
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="426.342"
                    y="196.579"
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="434.932"
                    y="196.579"
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <path
                    d="M348.747 84.7397C356.728 96.9993 358.169 128.847 357.892 143.238H324.637C325.08 105.162 330.549 88.3744 333.228 84.7397H348.747Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M459.641 69.8574C468.279 85.2359 469.839 125.185 469.539 143.238H433.547C434.027 95.4758 439.945 74.4167 442.845 69.8574H459.641Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M344.813 110.231C349.199 117.149 349.99 135.118 349.838 143.238H331.565C331.809 121.755 334.814 112.282 336.286 110.231H344.813Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M456.313 96.3806C461.097 103.73 461.961 122.822 461.795 131.45H441.86C442.126 108.624 445.404 98.5596 447.01 96.3806H456.313Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="337.83"
                    y="133.334"
                    width="5.20525"
                    height="8.9039"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="333.781"
                    y="77.2253"
                    width="12.7477"
                    height="1.1788"
                    rx="0.5894"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="336.276"
                    y="70.4468"
                    width="7.75949"
                    height="1.1788"
                    rx="0.5894"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="88.2404"
                    height="55.3521"
                    transform="matrix(-1 0 0 1 673.362 190.297)"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    width="88.0589"
                    height="23.4471"
                    transform="matrix(-1 0 0 1 673.362 222.202)"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    width="88.0589"
                    height="14.9848"
                    transform="matrix(-1 0 0 1 673.362 190.297)"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M710.699 198.818V159.207H644.035V190.489H673.277V198.818H710.699Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    width="11.2179"
                    height="12.7982"
                    transform="matrix(-1 0 0 1 697.238 169.738)"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    width="11.2179"
                    height="12.7982"
                    transform="matrix(-1 0 0 1 670.919 169.738)"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.407 255.519H585.11V190.299H644.16V159.168H710.757V143.184H514.407"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.407 151.036H710.757V159.208H514.407"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.436 206.204H585.094V214.405H514.436"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.436 214.404H585.094V222.605H514.436"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.436 222.605H585.094V230.806H514.436"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.436 230.805H585.094V239.006H514.436"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M514.436 239.005H585.094V247.206H514.436"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="-1"
                    y="1"
                    width="9.76833"
                    height="14.5749"
                    transform="matrix(-1 0 0 1 701.248 234.906)"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M624.242 174.981V190.333M624.242 174.981C632.691 162.699 641.004 169.864 644.105 174.981V190.333H624.242M624.242 174.981C617.626 169.864 600.514 162.699 584.995 174.981V190.333H624.242"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M545.506 175.065C560.692 161.156 578.161 169.27 584.996 175.065V206.156H545.506V175.065Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M524.306 175.066C532.73 162.217 541.949 169.712 545.506 175.066V206.157H524.306M524.306 175.066V206.157M524.306 175.066C523.243 172.168 519.789 166.431 514.468 166.667M524.306 206.157H514.468"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M717.323 222.365C717.323 224.841 717.323 249.821 717.323 262.002H514.19M514.467 206.157H584.996V205.272H673.26V198.789H710.672L717.184 222.218"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M673.398 222.217H717.323V262.002H683.791L673.398 245.499V222.217Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M665.501 233.121V245.646H658.019V233.121C660.79 229.349 664.162 231.549 665.501 233.121Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M650.813 233.121V245.646H643.331V233.121C646.102 229.349 649.474 231.549 650.813 233.121Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M635.294 233.121V245.646H627.812V233.121C630.583 229.349 633.955 231.549 635.294 233.121Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 662.729 251.098)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 654.138 251.098)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 645.547 251.098)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 636.957 251.098)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 628.366 251.098)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 619.775 251.098)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 611.184 251.098)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 602.593 251.098)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="5.894"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 594.002 251.098)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 662.729 196.579)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 654.138 196.579)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 645.547 196.579)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 636.957 196.579)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 628.366 196.579)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 619.775 196.579)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 611.184 196.579)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 602.593 196.579)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="1.1085"
                    height="2.947"
                    rx="0.55425"
                    transform="matrix(-1 0 0 1 594.002 196.579)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <path
                    d="M680.188 84.7397C672.207 96.9993 670.766 128.847 671.043 143.238H704.298C703.854 105.162 698.386 88.3744 695.707 84.7397H680.188Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M569.294 69.8574C560.656 85.2359 559.096 125.185 559.396 143.238H595.388C594.908 95.4758 588.99 74.4167 586.09 69.8574H569.294Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M684.122 110.231C679.736 117.149 678.944 135.118 679.097 143.238H697.37C697.126 121.755 694.121 112.282 692.649 110.231H684.122Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M572.622 96.3806C567.838 103.73 566.974 122.822 567.14 131.45H587.074C586.808 108.624 583.53 98.5596 581.925 96.3806H572.622Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    x="-1"
                    y="1"
                    width="5.20525"
                    height="8.9039"
                    transform="matrix(-1 0 0 1 690.105 132.334)"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <rect
                    width="12.7477"
                    height="1.1788"
                    rx="0.5894"
                    transform="matrix(-1 0 0 1 695.154 77.2253)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    width="7.75949"
                    height="1.1788"
                    rx="0.5894"
                    transform="matrix(-1 0 0 1 692.658 70.4468)"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="510.864"
                    y="28.6001"
                    width="7.75949"
                    height="1.1788"
                    rx="0.5894"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="447.958"
                    y="56.5962"
                    width="7.75949"
                    height="1.1788"
                    rx="0.5894"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="573.495"
                    y="56.8911"
                    width="7.75949"
                    height="1.1788"
                    rx="0.5894"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <path
                    d="M390.052 125.77C387.59 127.445 385.958 130.379 385.958 133.718C385.958 138.924 389.927 143.145 394.823 143.145C399.719 143.145 403.688 138.924 403.688 133.718C403.688 130.417 402.093 127.512 399.678 125.828C399.412 125.681 399.154 125.52 398.904 125.346L398.17 124.777C396.218 123.101 394.935 120.578 394.813 117.734C394.692 120.587 393.401 123.117 391.439 124.793L390.639 125.404C390.448 125.533 390.252 125.656 390.052 125.77Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M628.946 125.77C626.484 127.445 624.851 130.379 624.851 133.718C624.851 138.924 628.821 143.145 633.717 143.145C638.613 143.145 642.582 138.924 642.582 133.718C642.582 130.417 640.987 127.512 638.572 125.828C638.306 125.681 638.047 125.52 637.798 125.346L637.063 124.777C635.112 123.101 633.829 120.578 633.707 117.734C633.585 120.587 632.295 123.117 630.332 124.793L629.533 125.404C629.342 125.533 629.146 125.656 628.946 125.77Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M511.875 132.695C510.394 133.703 509.412 135.467 509.412 137.475C509.412 140.607 511.8 143.146 514.745 143.146C517.69 143.146 520.077 140.607 520.077 137.475C520.077 135.49 519.118 133.743 517.665 132.73C517.505 132.641 517.349 132.545 517.199 132.44L516.758 132.098C515.584 131.089 514.812 129.572 514.739 127.862C514.666 129.578 513.889 131.099 512.709 132.108L512.228 132.475C512.113 132.553 511.996 132.626 511.875 132.695Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                {/* hall ended */}
            </svg>

            <g>
                <path
                    d="M921.303 261.992H851.802L856.837 227.853H916.268L921.303 261.992Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M911.915 222.155H861.845V227.853H911.915V222.155Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M905.149 215.941H869.061V222.155H905.149V215.941Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M875.935 15.8799H897.592L901.523 215.942H872.193L875.935 15.8799Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M882.81 15.8799L881.203 215.942H892.323L890.716 15.8799H882.81Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M903.658 261.992H870.326L871.699 227.853H901.522L903.658 261.992Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M894.728 243.314L895.186 261.992"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M886.167 241.367V261.992"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M877.083 251.674V261.991"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M877.083 239.248V247.618"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M886.167 232.672V236.652"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M895.187 233.97V240.059"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
            </g>

            <svg>
                <path
                    d="M1375.87 183.568H1117.7V244.123H1375.87V183.568Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1220.06 183.568H1117.7V203.324H1220.06V183.568Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1220.06 203.323H1117.7V223.715H1220.06V203.323Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1220.06 223.714H1117.7V244.106H1220.06V223.714Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1376.1 183.551H1273.74V203.307H1376.1V183.551Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1375.87 203.323H1273.52V223.715H1375.87V203.323Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1375.87 223.714H1273.52V244.106H1375.87V223.714Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1273.52 203.323H1220.06V244.111H1273.52V203.323Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1281.68 47.5688H1209.96V61.09H1281.68V47.5688Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1273.73 73.8918C1275.07 74.1997 1276.37 74.6113 1277.65 75.1231V61.0679H1273.73V73.8918Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1219.35 73.8918C1218.02 74.1997 1216.72 74.6113 1215.44 75.1231V61.0679H1219.35V73.8918Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1355.85 183.568H1137.73C1137.82 179.713 1138.08 175.864 1138.53 172.037C1138.96 168.298 1139.59 164.599 1140.33 160.95C1141.94 153.327 1144.26 145.896 1147.27 138.771C1148.87 134.974 1150.67 131.272 1152.65 127.684C1154.77 123.851 1157.09 120.15 1159.61 116.598C1162.37 112.705 1165.35 109.002 1168.55 105.511H1325.01C1328.21 109.002 1331.2 112.705 1333.96 116.598C1336.47 120.15 1338.79 123.851 1340.91 127.684C1346.62 138.025 1350.78 149.246 1353.24 160.945C1354.01 164.592 1354.62 168.287 1355.05 172.031C1355.5 175.86 1355.77 179.711 1355.85 183.568Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1273.52 164.031H1281.51"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1273.52 175.477H1281.51V173.464H1273.52V175.477Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1220.06 175.477H1211.27V173.51H1220.06V175.477Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1318.4 98.8316C1312.27 93.1622 1305.58 88.2315 1298.44 84.1299"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1273.52 183.568H1220.06V203.324H1273.52V183.568Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1298.68 83.1297C1282.73 74.0468 1264.9 69.3047 1246.8 69.3334C1228.6 69.3094 1210.69 74.0973 1194.67 83.262L1191.41 85.13H1191.55C1187.42 87.6903 1183.45 90.5326 1179.66 93.6394L1177.5 95.4125H1180.3H1313.32H1316.11L1313.95 93.6395C1310.16 90.5315 1306.19 87.6891 1302.06 85.13H1302.18L1299.82 83.7823C1299.53 83.6075 1299.23 83.4342 1298.93 83.2624L1298.7 83.1297H1298.68ZM1294.51 83.1297C1279.69 75.3509 1263.36 71.307 1246.8 71.3334L1246.8 71.3334C1230.23 71.3113 1213.9 75.3549 1199.07 83.1297H1294.51ZM1195.45 85.13H1298.16C1302.43 87.5947 1306.54 90.3618 1310.46 93.4125H1183.15C1187.07 90.3633 1191.18 87.5962 1195.45 85.13Z"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <path
                    d="M1246.15 209.395C1252.73 209.395 1258.08 214.258 1258.08 220.252V243.864H1234.22V220.285C1234.22 214.286 1239.56 209.429 1246.16 209.429L1246.15 209.395Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1219.81 244.253V148.132V148.306V244.269V244.253Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1273.74 244.269V148.132V148.132V244.247V244.269Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1220.06 164.014C1220.06 164.014 1246.46 144.488 1273.52 164.014V175.46C1273.52 175.46 1248.75 155.013 1220.06 175.46V164.014Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1217.31 164.031H1211.27V165.836H1217.31V164.031Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1282.32 164.031H1275.99V165.836H1282.32V164.031Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1250.76 136.246L1241.53 146.057C1241.1 145.602 1240.73 145.083 1240.44 144.516L1249.3 135.082C1249.84 135.395 1250.33 135.786 1250.76 136.246Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1252.67 141.154C1252.67 141.59 1252.63 142.025 1252.55 142.453C1252.31 143.821 1251.69 145.079 1250.76 146.063C1249.84 147.047 1248.65 147.711 1247.37 147.968C1246.97 148.052 1246.56 148.094 1246.15 148.092C1245.71 148.091 1245.27 148.044 1244.84 147.952C1244.19 147.812 1243.56 147.565 1242.98 147.221C1242.45 146.908 1241.96 146.519 1241.53 146.063C1241.1 145.608 1240.73 145.089 1240.44 144.522C1239.9 143.491 1239.62 142.329 1239.62 141.149C1239.62 140.707 1239.66 140.267 1239.74 139.833C1239.99 138.473 1240.61 137.223 1241.53 136.243C1242.45 135.263 1243.63 134.599 1244.91 134.335C1245.32 134.254 1245.73 134.212 1246.15 134.211C1246.58 134.21 1247.02 134.255 1247.44 134.346C1248.7 134.619 1249.85 135.278 1250.76 136.241C1251.19 136.696 1251.55 137.215 1251.85 137.781C1252.17 138.396 1252.4 139.062 1252.53 139.755C1252.62 140.215 1252.67 140.684 1252.67 141.154Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1247.44 134.352L1239.74 142.532C1239.66 142.078 1239.62 141.617 1239.62 141.154C1239.62 140.713 1239.66 140.272 1239.73 139.839L1244.9 134.34C1245.31 134.259 1245.73 134.218 1246.14 134.217C1246.58 134.216 1247.01 134.261 1247.44 134.352Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1252.54 139.76L1244.84 147.951C1244.19 147.811 1243.56 147.565 1242.98 147.22L1251.85 137.787C1252.18 138.402 1252.41 139.068 1252.54 139.76Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1252.67 141.154C1252.67 141.59 1252.63 142.025 1252.55 142.453L1247.37 147.968C1246.97 148.052 1246.56 148.094 1246.15 148.092C1245.71 148.091 1245.27 148.044 1244.84 147.951L1252.54 139.76C1252.63 140.219 1252.67 140.686 1252.67 141.154Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1246.15 212.707C1248.61 212.707 1250.98 213.748 1252.72 215.601C1254.46 217.455 1255.44 219.969 1255.44 222.59V244.083H1236.86V222.618C1236.86 219.996 1237.84 217.482 1239.59 215.628C1241.33 213.773 1243.69 212.731 1246.16 212.729L1246.15 212.707Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1119.45 157.267H1122.11C1123.58 157.267 1124.78 155.996 1124.78 154.428V154.422C1124.78 152.854 1123.58 151.583 1122.11 151.583H1119.45C1117.97 151.583 1116.78 152.854 1116.78 154.422V154.428C1116.78 155.996 1117.97 157.267 1119.45 157.267Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1374.17 157.267H1371.51C1370.03 157.267 1368.84 155.996 1368.84 154.428V154.422C1368.84 152.854 1370.03 151.583 1371.51 151.583H1374.17C1375.64 151.583 1376.84 152.854 1376.84 154.422V154.428C1376.84 155.996 1375.64 157.267 1374.17 157.267Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1120.78 151.578V146.866"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1372.84 151.578V146.866"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1119.4 183.573H1122.16V157.268H1119.4V183.573Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1374.22 183.573H1371.46V157.268H1374.22V183.573Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1129.43 168.995H1132.09C1133.56 168.995 1134.76 167.724 1134.76 166.156V166.15C1134.76 164.582 1133.56 163.311 1132.09 163.311H1129.43C1127.96 163.311 1126.76 164.582 1126.76 166.15V166.156C1126.76 167.724 1127.96 168.995 1129.43 168.995Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1364.19 168.995H1361.53C1360.05 168.995 1358.86 167.724 1358.86 166.156V166.15C1358.86 164.582 1360.05 163.311 1361.53 163.311H1364.19C1365.66 163.311 1366.86 164.582 1366.86 166.15V166.156C1366.86 167.724 1365.66 168.995 1364.19 168.995Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1130.76 163.306V158.594"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1362.86 163.306V158.594"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1129.38 183.568H1132.14V168.99H1129.38V183.568Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1364.24 183.568H1361.48V168.99H1364.24V183.568Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1375.87 244.106H1117.7V252.747H1375.87V244.106Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M1381.09 252.82H1112.49V261.81H1381.09V252.82Z"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <rect
                    x="1125.18"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1133.64"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1142.1"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1150.56"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1159.02"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1167.47"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1175.93"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1184.39"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1192.85"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1201.31"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1209.77"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1125.18"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1133.64"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1142.1"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1150.56"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1159.02"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1167.47"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1175.93"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1184.39"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1192.85"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1201.31"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1209.77"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1282.2"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1290.66"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1299.11"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1307.57"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1316.03"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1324.49"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1332.95"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1341.41"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1349.87"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1358.33"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1366.79"
                    y="230.776"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1282.2"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1290.66"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1299.11"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1307.57"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1316.03"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1324.49"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1332.95"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1341.41"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1349.87"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1358.33"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1366.79"
                    y="190.297"
                    width="1.58604"
                    height="6.18429"
                    rx="0.79302"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1237.92"
                    y="39.6248"
                    width="17.7159"
                    height="1.12442"
                    rx="0.562208"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1242.23"
                    y="35.1272"
                    width="9.10011"
                    height="1.12442"
                    rx="0.562208"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <rect
                    x="1244.13"
                    y="30.6299"
                    width="5.2868"
                    height="1.12442"
                    rx="0.562208"
                    fill="#777777"
                    className={styles.rectWithFill}
                />
                <path
                    d="M1325.01 105.509C1324.31 104.666 1322.01 102.038 1318.21 98.6648"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
                <path
                    d="M1168.53 105.534C1169.85 104.093 1174.09 99.2343 1181.22 93.7085"
                    stroke="#777777"
                    stroke-width="2"
                    stroke-linejoin="round"
                />
            </svg>

            <g>
                <path
                    d="M1665.58 66.1275L1883.43 226.631M1662.13 51.4694C1663.59 52.4378 1912.38 182.657 1912.38 182.657M1659.37 6.03003V244.953L1647.65 247.152V11.1603L1659.37 6.03003ZM1659.37 6.03003L1664.89 8.22871V244.953L1659.37 245.686M1717.28 132.088L1747.62 136.485M1665.58 122.56L1694.53 126.225M1711.77 24.3523C1712.24 25.322 1716.59 27.2839 1716.59 27.2839V240.556L1711.08 242.022H1704.87M1711.77 24.3523L1703.49 27.2839L1704.87 26.551V241.289H1711.77L1711.77 24.3523ZM1683.5 22.1536L1694.53 17.7563L1694.53 242.755L1684.19 243.487V22.1537M1695.22 17.0236L1700.74 19.9551V240.556L1694.53 242.022M1741.41 34.613L1748.3 38.2774V238.357H1740.72L1732.45 239.09M1662.13 22.1537L1904.11 122.56M1662.13 30.2155C1666.67 33.6333 1894.46 131.355 1894.46 131.355M1662.13 39.0103L1897.21 155.54M1665.58 82.2508L1860.68 226.631M1665.58 88.847L1831.03 231.761M1665.58 98.3746L1778.64 236.159M1664.89 113.765C1666.23 116.961 1722.11 240.556 1722.11 240.556M1665.58 104.97L1755.2 236.158M1586.99 252.282C1591.26 251.883 1888.25 226.631 1888.25 226.631V235.425L1586.99 261.81C1586.99 261.81 1582.72 252.681 1586.99 252.282ZM1666.27 117.43L1695.22 121.094V131.355L1665.58 128.423L1666.27 117.43ZM1717.28 125.492L1741.41 129.156L1748.31 132.088L1747.62 140.149L1716.59 137.951L1717.28 125.492ZM1730.38 39.0101L1740.72 35.3457V237.624L1733.14 239.09L1730.38 39.0101Z"
                    stroke="#777777"
                    stroke-width="1.75593"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
        </svg>
    );
};
